import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { AppScope } from '../appScope.types';
import { StashedAppScope } from './StashedAppScope';

/** The production sidebar's opener scope (`productionSidebarAppScope`). */
export function PortaledProductionSidebarAppScope({
  children
}: {
  children: ReactNode;
}) {
  const stashed = useSelector(
    (state: { ui: { productionSidebarAppScope: AppScope | null } }) =>
      state.ui.productionSidebarAppScope
  );
  return <StashedAppScope stashed={stashed}>{children}</StashedAppScope>;
}
